import React, { useEffect, useState, useMemo } from "react";
import {
  Container,
  Typography,
  ListItemIcon,
  Button,
  Tooltip,
  MenuItem,
  AppBar,
  Toolbar,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from '@mui/icons-material/Close';
import AddBoxTwoToneIcon from "@mui/icons-material/AddBoxTwoTone";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import { MRT_Localization_ES } from 'material-react-table/locales/es';
import { getData } from "../../../../../services/library";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import { Delete } from "@mui/icons-material";
import ChoferZona from "../ChoferZona/ChoferZona";
import BlockIcon from '@mui/icons-material/Block';
import MarcarActivoZona from "./activo/MarcarActivoZona";
import BajaZona from "./baja/BajaZona";
import EdicionZona from "./edicion/EdicionZona";
import AltaZona from "./alta/AltaZona";

function ZonasGeograficas(props) {
  const [choferZona, setChoferZona] = useState(false)
  const [editar, setEditar] = useState(false); //Estado q mostrará o no el form de edicion de clientes
  const [alta, setAlta] = useState(false); //Estado q mostrará o no la pantalla de alta
  const [baja, setBaja] = useState(false); //Abre formulario
  const [tabla, setTabla] = useState(true)
  const [zonas, setZonas] = useState()
  const [dataRow, setDataRow] = useState()
  const [marcarActivo, setMarcarActivo] = useState(false);
  const [grupo, setGrupo] = useState(props.dataGrupo)

  //Tabla
  const [hiddenmuestrainactivo, setHiddenmuestrainactivo] = useState(false);
  const [hiddenmuestraactivos, setHiddenmuestraactivos] = useState(true);

  
  const obtenerZonasInactivos = () => {
    setHiddenmuestrainactivo(true);
    setHiddenmuestraactivos(false);
    getData("/envasado_zona/xgrupoinactivo/"+props.dataGrupo.id, setZonas)
  };
    
    //Funcion para traer los clientes a la tabla TODOS :ACTIVOS E INACTIVOS
  const obtenerZonas = () => {
    setHiddenmuestraactivos(true);
    setHiddenmuestrainactivo(false);
    getData("/envasado_zona/xgrupoactivo/"+props.dataGrupo.id, setZonas);
  };
  
  useEffect(() => {
    obtenerZonas()
  }, [])

  const handleClickNuevo = () => {
    setAlta(true); //pongo alta en true para q muestre el componente Addcliente
  };

  const handleClose = () => {
    props.onClose(false);
  };

  const handleCloseVerChoferZona = () => {
    setChoferZona(false)
    setTabla(true)
    obtenerZonas()
  };

  const handleCloseAlta = () => {
    setAlta(false)
    setTabla(true)
    obtenerZonas()
  };

  const handleCloseEditar = () => {
    setEditar(false)
    setTabla(true)
    obtenerZonas()
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "id", //access nested data with dot notation
        header: "ID",
        maxSize: 100,
      },
      {
        accessorKey: "nombre", //access nested data with dot notation
        header: "Zona",
        maxSize: 100,
      },
      {
        accessorKey: "descripcion", //access nested data with dot notation
        header: "Descripción",
        maxSize: 100,
      },
    ],
    []
  );

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "success",
    size: "small",
  };
  
  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 10 },
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  const displayColumnDefOptions = {
    "mrt-row-actions": {
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
    },
  };
  return (
    <div>
    {tabla &&
    <>
      <AppBar
        sx={{ position: "relative" }}
        style={{ backgroundColor: "#0979b0" }}
      >
        <Toolbar>
          <IconButton
            edge="start"
            color="inherit"
            onClick={()=>handleClose()}
            aria-label="close"
          >
            <CloseIcon />
          </IconButton>
          <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
            Zonas del Grupo {props.dataGrupo.nombre}
          </Typography>
        </Toolbar>
      </AppBar>
      <MaterialReactTable 
      localization={MRT_Localization_ES}
      columns={columns}
      data={zonas ?? [{}]}
      layoutMode={"grid"}
      initialState={initialState}
      enableColumnActions={false}
      enableGlobalFilterModes={false}
      enableHiding={false}
      enableRowActions={true}
      enableColumnFilters={false}
      enableFullScreenToggle={false}
      positionActionsColumn={"last"}
      enableExpandAll={false}
      enableToolbarInternalActions={true}
      muiTableHeadCellProps={tableHeadCellProps}
      muiSearchTextFieldProps={muiSearchTextFieldProps}
      enableDensityToggle={false}
      displayColumnDefOptions={displayColumnDefOptions}
      enableColumnResizing={true}
      muiTableBodyCellProps={({ row }) => ({
        align: "left",
          sx: {
            backgroundColor: row.original.activo === 1 ? "#b3e6b3" : "#efc3c3",
            color: "black",
          },
      })}
      renderTopToolbarCustomActions={(row,table) => (
        <>
          <Button
            variant="contained"
            color="primary"
            startIcon={<AddBoxTwoToneIcon color="asd" />}
            onClick={handleClickNuevo}
          >
            Agregar Zona
          </Button>
        </>
      )}
      renderToolbarInternalActions={(row,table) => (
        <>
          {!hiddenmuestrainactivo ? (
            <Tooltip title="Muestra Inactivos">
              <IconButton
                onClick={() => obtenerZonasInactivos()}
                color="error"
              >
                <BlockIcon />
              </IconButton>
            </Tooltip>
          ) : null}
          {!hiddenmuestraactivos ? (
            <Tooltip title="Mostrar ACTIVOS" color="success">
              <IconButton onClick={() => obtenerZonas()}>
                <CheckCircleOutlineIcon />
              </IconButton>
            </Tooltip>
          ) : null}
        </>
      )}
      renderRowActionMenuItems={ ({ closeMenu, row, index }) => [
        <MenuItem
          key={index}
          style={{
            display: row.original.activo === 0 ? null : "none",
          }}
          disabled={row.original.activo === 1}
          onClick={() => {
            setMarcarActivo(true);
            setDataRow(row.original);
            closeMenu();
          }}
          sx={{ m: 0 }}
        >
          <ListItemIcon>
            <CheckCircleOutlineIcon color="success" />
          </ListItemIcon>
          Marcar Activo
        </MenuItem>,
  
        <MenuItem
          key={index}
          style={{
            display: row.original.activo === 0 ? "none" : null,
          }}
          disabled={row.original.activo === 0}
          onClick={() => {
            closeMenu();
            setDataRow(row.original);
            setEditar(true);
          }}
          sx={{ m: 0 }}
        >
          <ListItemIcon>
            <BorderColorIcon color="primary" />
          </ListItemIcon>
          Editar
        </MenuItem>,
  
        <MenuItem
        key={index}
        style={{
          display: row.original.activo === 0 ? "none" : null,
        }}
        disabled={row.original.activo === 0}
        onClick={() => {
          closeMenu();
          setDataRow(row.original);
          setChoferZona(true);
          setTabla(false)
        }}
        sx={{ m: 0 }}
        >
        <ListItemIcon>
          <LocalShippingIcon color="secondary" />
        </ListItemIcon>
        Ver Choferes
        </MenuItem>,
  
        <MenuItem
          key={index}
          style={{
            display: row.original.activo === 0 ? "none" : null,
          }}
          disabled={row.original.activo === 0}
          onClick={() => {
            closeMenu();
            setDataRow(row.original);
            setBaja(true);
          }}
          sx={{ m: 0 }}
        >
          <ListItemIcon>
            <Delete color="error" />
          </ListItemIcon>
          Marcar Inactivo
        </MenuItem>,
      ]}
      />
    </>
    }
    {choferZona &&
      <ChoferZona
        dataZona={dataRow}
        onClose={() => handleCloseVerChoferZona()}    
      />
    }
    {marcarActivo?
      <MarcarActivoZona
        open={marcarActivo}
        setOpen={setMarcarActivo}
        zona={dataRow}
        tabla={setTabla}
        actualizar={obtenerZonas}
      />
    :null}
    {baja && (
      <BajaZona
        open={baja}
        setOpen={setBaja}
        zona={dataRow}
        tabla={setTabla}
        actualizar={obtenerZonas}
      />
    )}
    {editar?
      <EdicionZona
        editar={editar}
        datosRow={dataRow}
        grupo={grupo}
        onClose={() => handleCloseEditar(false)}
      />
    :null}
    {alta?
      <AltaZona
      alta={alta}
      grupo={grupo}
      onClose={() => handleCloseAlta(false)}
      />
    :null}
    </div>
  )
}

export default ZonasGeograficas